import { gsap } from "gsap";
import { Button } from "./Button";
import vertexShader from '../shaders/default_vert.glsl'
import fragmentShader from '../shaders/switchButton_frag.glsl'

export class SwitchButton extends Button {

    constructor({ name, assets, textureIds, aspectRatio=1 }) {
        super({ name, assets, textureIds, aspectRatio });

        this.toggled = false;
    }

    getUniforms() {
        // Add the custom toggle value
        return {
            ...super.getUniforms(),
            toggle: { value: 0 },
        }
    }

    // This one uses two map states
    getMap() {
        return {
            map1: { value: this.assets.textures[this.textureIds[0]] },
            map2: { value: this.assets.textures[this.textureIds[1]] },
        }
    }

    getShaders() {
        return {
            vertexShader,
            fragmentShader,
        }
    }

    toggle(state) {
        this.toggled = state;

        gsap.to(this.material.uniforms.toggle, {
            value: this.toggled ? 1 : 0
        });
    }
}